module.exports = __webpack_public_path__ + "images/money.png";